module.exports = __webpack_public_path__ + "img/right.a3b5c86f.png";